import styled from 'styled-components';
import {
  whiteColor,
  inputBorderColor,
  mediumFont,
  primaryColor,
} from '@app/styles';

export const InputContainer = styled.div`
  position: relative;
  margin-bottom: 20px;
  .react-autosuggest__container {
    position: relative;
  }
  .react-autosuggest__input {
    width: 100%;
    height: 44px;
    margin-top: 5px;
    padding: 10px 12px;
    border: 1px solid ${inputBorderColor};
    border-radius: 3px;
    color: #2d3448;
    box-shadow: none;
    outline: none;
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    ::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
    background-color: #fafbfc;
    border-color: ${inputBorderColor};
    &:disabled {
      background-color: ${whiteColor};
      color: grey;
      cursor: not-allowed;
      border-color: ${inputBorderColor};
      &:hover {
        background-color: ${whiteColor};
        border-color: ${inputBorderColor};
        color: grey;
      }
      &:active,
      &:focus {
        background-color: ${whiteColor};
        border-color: ${inputBorderColor};
      }
    }
    &:hover {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
    &:active,
    &:focus {
      background-color: ${whiteColor};
      border-color: ${primaryColor};
    }
  }

  .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .react-autosuggest__suggestions-container {
    display: none;
  }

  .react-autosuggest__suggestions-container--open {
    display: block;
    position: absolute;
    width: 100%;
    max-height: 200px;
    border: 2px solid ${inputBorderColor};
    background-color: ${whiteColor};
    border-radius: 3px;
    z-index: 2;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
  }

  .react-autosuggest__suggestion--highlighted {
    background-color: rgb(179, 209, 255);
  }
`;
export const Label = styled.label`
  font-size: 15px;
  color: #0f1d2a;
  opacity: 0.5;
  text-align: left;
  line-height: 21px;
  ${mediumFont}
`;
export const Star = styled.label`
  font-size: 15px;
  color: red;
  text-align: left;
  line-height: 21px;
  ${mediumFont}
`;
